// Handles token after Google OAuth
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    const email = url.searchParams.get("email");
    const name = url.searchParams.get("name");
    const phone = url.searchParams.get("phone");
    const avatar = url.searchParams.get("avatar");

    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("email", email);
      localStorage.setItem("name", name);
      localStorage.setItem("phone", phone);
      localStorage.setItem("avatar", avatar);
      navigate("/");
    }
  }, []);

  return <p>Logging in via Google...</p>;
};

export default AuthSuccess;
